






import { Component, Mixins } from "vue-property-decorator";
import { DocumentReferableMixin } from "../mixins";

@Component
export default class DocumentEditModeIndicator extends Mixins(DocumentReferableMixin) {
  get isNew(): boolean {
    return this.readPropertyOrDefault(s => !s.source.documentId, null);
  }

  get label(): string {
    return ((this.isNew !== undefined) && (this.isNew !== null))
      ? (this.isNew ? "新規" : "編集")
      : "";
  }
}
